<app-form-layout-top>
  <app-financing-form-top></app-financing-form-top>
</app-form-layout-top>
<app-form-layout>
  <app-form-layout-content>
    <app-form-layout-progress>
      <app-financing-form-progress></app-financing-form-progress>
    </app-form-layout-progress>
    <app-form-layout-main>
      <app-form-layout-middle>
        <app-perex [form]="true">
          <app-form-layout-title>{{ 'financingForm.calculator.title' | translate }}</app-form-layout-title>
          <app-paragraph [font-size]="'small'">{{ 'financingForm.calculator.description' | translate }}</app-paragraph>
        </app-perex>
        @if (ssrService.isBrowser() && loaded() && car()) {
          <div class="financing-form-calculator__calculator">
            <app-financing-calculator-form [car-id]="car()!.id" [car-price]="car()!.price.cash" [car-payment-options]="car()!.paymentOptions" [active-advance]="advance" [active-months]="months" [type]="'financing-form'" (data-changed)="calculatorChanged($event)"></app-financing-calculator-form>
          </div>
        } @else {
          <app-loader></app-loader>
        }
      </app-form-layout-middle>
      <app-form-layout-sidebar [title]="'financingForm.sidebar.summary.title' | translate">
        <app-financing-form-sidebar [car]="car()"></app-financing-form-sidebar>
      </app-form-layout-sidebar>
    </app-form-layout-main>
  </app-form-layout-content>

  <app-form-layout-footer>
    <app-financing-form-footer [months]="months" [advance]="advance" (clicked)="saveData()"></app-financing-form-footer>
  </app-form-layout-footer>
</app-form-layout>
